import React from "react";
import { COMPANY } from "@/lib/site";

/** Thin navy / teal / orange brand stripe used at the top of the header and footer. */
export const BrandBar = ({ order = "navy" }) => {
  const colours =
    order === "navy"
      ? ["bg-[#0b1d3a]", "bg-[#148a8f]", "bg-[#f28a2e]"]
      : ["bg-[#1aa3a8]", "bg-[#f28a2e]", "bg-[#123055]"];

  return (
    <div className="flex h-1.5 w-full" aria-hidden="true">
      {colours.map((colour) => (
        <span key={colour} className={`h-full flex-1 ${colour}`} />
      ))}
    </div>
  );
};

export const HeaderLogo = () => (
  <button
    type="button"
    data-testid="header-logo-button"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className="flex items-center gap-3 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1aa3a8]"
    aria-label={`${COMPANY.name} home`}
  >
    <img
      src={COMPANY.logo}
      alt={`${COMPANY.name} logo`}
      className="h-20 w-auto object-contain sm:h-24 lg:h-[7.5rem]"
      width="400"
      height="120"
    />
    <span className="sr-only">{COMPANY.name}</span>
  </button>
);
